import { createSelector } from 'reselect';

export const selectedPendingClaims = (state: any) => {
  return state.get('managerPendingTreatementClaims');
};

const makeSelectPendingTreatementClaims = () =>
  createSelector(selectedPendingClaims, claims => {
    if (claims && claims.get('pendingClaims')) {
      return claims.get('pendingClaims').toJS();
    }
    return [];
  });
const makeSelectCountPendingTreatementClaims = () =>
  createSelector(selectedPendingClaims, claims => {
    if (claims && claims.get('count')) {
      return claims.get('count');
    }
    return [];
  });

export {
  makeSelectPendingTreatementClaims,
  makeSelectCountPendingTreatementClaims,
};
